module.exports = __webpack_public_path__ + "static/media/normalized_series.7ea2600c.svg";